import React, { useState, useEffect } from 'react'
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';
import { LightTheme, BaseProvider } from 'baseui';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import SignUp from './screen/SignUp';
import AccountRetrive from './screen/AccountRetrive';
import PaymentPage from './screen/PaymentPage';
const engine = new Styletron();
import { SnackbarProvider, } from 'baseui/snackbar';
import PaymentGatewaySelectPage from './screen/PaymentGatewaySelectPage';
import PaymentSuccessPage from './screen/PaymentSuccessPage';

export const UserContext = React.createContext();

function App() {

  const [name, setName] = useState("");
  const [orcaAPIKey, setOrcaAPIKey] = useState("");
  const [uid, setUid] = useState("");
  const [selectedPgs, setSelectedPgs] = useState([]);
  const [selectedPg, setSelectedPg] = useState("");

  useEffect(() => {
    let data = localStorage.getItem('cache');

    if (data) {
      let object = JSON.parse(data)
      setValue("name", object["name"])
      setValue("orcaAPIKey", object["orcaAPIKey"])
      setValue("uid", object["uid"])
      setValue("selectedPgs", object["selectedPgs"])
      setValue("selectedPg", object["selectedPg"])
    }

  }, []);

  let setValue = (key, value) => {
    let localCopy = selectedPgs
    let localPg = selectedPg
    switch (key) {
      case "name": setName(value)
        break;
      case "orcaAPIKey": setOrcaAPIKey(value)
        break;
      case "uid": setUid(value)
        break;
      case "selectedPgs": setSelectedPgs(value)
        localCopy = value
        break;
      case "selectedPg": setSelectedPg(value)
        localPg = value
        break;
    }

    if (name && uid && orcaAPIKey) {
      let data = JSON.stringify({
        name,
        orcaAPIKey,
        uid,
        selectedPg: localPg,
        selectedPgs: localCopy
      })
      console.log(data)
      localStorage.setItem("cache", data)
    }
  }

  let contextValue = {
    name,
    orcaAPIKey,
    uid,
    selectedPgs,
    selectedPg,
    setValue
  }

  return (
    <StyletronProvider value={engine}>
      <BaseProvider theme={LightTheme}>
        <UserContext.Provider value={contextValue}>
          <SnackbarProvider>
            <div className='w-screen h-screen flex flex-col justify-center align-middle' >
              <BrowserRouter>
                <Routes>
                  <Route path="*" index element={<SignUp />} />
                  <Route path="account-retrive" element={<AccountRetrive />} />
                  <Route path="payment-gateways" element={<PaymentGatewaySelectPage />} />
                  <Route path="test-payment" element={<PaymentPage />} />
                  <Route path="payment-success" element={<PaymentSuccessPage />} />
                </Routes>
              </BrowserRouter>
            </div>
          </SnackbarProvider>
        </UserContext.Provider>
      </BaseProvider >
    </StyletronProvider >
  );
}

export default App;

